/**
 * Estilos del modal de carga de documentos. El repo no usa hojas por componente, asi que viven
 * aqui y el modal los monta una vez en un <style>. Las animaciones respetan
 * prefers-reduced-motion.
 */
export const DOCUMENT_INTAKE_CSS = `
.di-drop {
  border: 2px dashed #b5c4d6;
  border-radius: 12px;
  padding: 22px 14px;
  text-align: center;
  cursor: pointer;
  background: #f7fafd;
  transition: border-color .2s, background .2s, transform .2s;
  outline: none;
}
.di-drop:hover, .di-drop:focus { border-color: #1e88ff; background: #eef6ff; }
.di-drop.di-dragging { border-color: #1e88ff; background: #e3f0ff; transform: scale(1.015); }
.di-drop-icon { font-size: 30px; color: #1e88ff; margin-bottom: 6px; }

.di-card {
  border: 1px solid #dbe5f0;
  border-radius: 12px;
  background: #fff;
  padding: 12px;
}
.di-card.di-done { border-color: #3fbf7f; background: #f4fbf7; }
.di-card.di-error { border-color: #e5484d; background: #fff6f6; }

.di-scan {
  position: relative;
  height: 150px;
  border-radius: 10px;
  overflow: hidden;
  background: #0b1b33;
  display: flex;
  align-items: center;
  justify-content: center;
}
.di-scan-preview { max-width: 100%; max-height: 100%; opacity: .75; }
.di-scan-icon { font-size: 56px; color: #6fb4ff; opacity: .85; }
.di-scan::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 10px;
  box-shadow: inset 0 0 0 2px rgba(60, 160, 255, .55);
  animation: di-pulse 1.6s ease-in-out infinite;
}
.di-scan-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, transparent, #4cc3ff 20%, #fff 50%, #4cc3ff 80%, transparent);
  box-shadow: 0 0 14px 4px rgba(76, 195, 255, .75);
  animation: di-sweep 2.2s ease-in-out infinite alternate;
}
.di-scan-line::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 3px;
  height: 46px;
  background: linear-gradient(to top, rgba(76, 195, 255, .28), transparent);
}

.di-progress { height: 6px; border-radius: 3px; background: #dbe5f0; overflow: hidden; }
.di-progress-bar { height: 100%; background: linear-gradient(90deg, #1e88ff, #4cc3ff); transition: width .25s; }
.di-progress-indeterminate .di-progress-bar {
  width: 40%;
  animation: di-slide 1.2s ease-in-out infinite;
}

.di-ai-banner {
  background: linear-gradient(100deg, #0b1b33, #124a8f);
  color: #fff;
  border-radius: 10px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.di-ai-banner .di-ai-icon { font-size: 22px; color: #6fd0ff; }
.di-ai-chip {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .04em;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(111, 208, 255, .18);
  color: #6fd0ff;
  margin-left: 6px;
}

@keyframes di-sweep { from { top: 0; } to { top: calc(100% - 3px); } }
@keyframes di-pulse { 0%, 100% { opacity: .45; } 50% { opacity: 1; } }
@keyframes di-slide { 0% { margin-left: -40%; } 100% { margin-left: 100%; } }

@media (prefers-reduced-motion: reduce) {
  .di-scan-line { animation: none; top: 50%; }
  .di-scan::after { animation: none; }
  .di-progress-indeterminate .di-progress-bar { animation: none; width: 100%; opacity: .6; }
  .di-drop, .di-progress-bar { transition: none; }
}
`;

/** Halos de los campos prellenados: verde = lo capturo la IA, naranja = falta capturarlo. */
export const HALO_CSS = `
.form-control.di-halo-ok {
  border-color: #3fbf7f;
  box-shadow: 0 0 0 3px rgba(63, 191, 127, .28);
}
.form-control.di-halo-missing:not(.is-invalid) {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, .30);
}
.di-summary {
  border: 1px solid #cfe0f5;
  border-left: 4px solid #1e88ff;
  border-radius: 8px;
  background: #f4f9ff;
  padding: 12px 14px;
}
.di-chip {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 999px;
  margin: 0 6px 6px 0;
}
.di-chip.ok { background: #e3f6ec; color: #1f8a56; }
.di-chip.missing { background: #fff1d6; color: #a86500; }
`;
